import { Grid, styled } from '@mui/material';
import { Fragment } from 'react';
// import OrderTable from './shared/OrderTable';
import CreateOrder from './shared/CreateOrder';
import { useState } from 'react';
import CollapsibleTable from './shared/CollapsibleTable';

const ContentBox = styled('div')(({ theme }) => ({
  margin: '30px',
  [theme.breakpoints.down('sm')]: { margin: '16px' }
}));

const Order = () => {
  const [apiCall, setApiCall] = useState(false);
  function handleApiCall() {
    setApiCall((prev) => !prev);
  }
  return (
    <Fragment>
      <ContentBox className='analytics'>
        <Grid container spacing={3}>
          <Grid item lg={12} md={12} sm={12} xs={12}>
            <CreateOrder handleApiCall={handleApiCall} />
            {/* <OrderTable apiCall={apiCall} setApiCall={setApiCall} /> */}
            <CollapsibleTable apiCall={apiCall} setApiCall={setApiCall} />
          </Grid>
        </Grid>
      </ContentBox>
    </Fragment>
  );
};

export default Order;
